module.exports = __webpack_public_path__ + "static/media/collaboration.dc191f83.svg";